// import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { Component, Inject } from '@angular/core';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { DataService } from "./data.service";
import { ToasterConfig } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { Title, DOCUMENT } from '@angular/platform-browser';
import { environment } from '../environments/environment';

var DEFAULT_LANG = "nl";
var ALLOWED_LANG = ["nl", "fr", "en", "de"];

function trigger_exit_poll(path, lng){
  let HJ_POLL_TRIGGER = 'show_exit_poll_' + lng;
  if( path === '/excent' ){
    HJ_POLL_TRIGGER = 'show_excent_poll_' + lng;
  }
  try{  window['hj']('trigger', HJ_POLL_TRIGGER) } catch (e) {};
}


if(!!window.location && window.location.hostname.indexOf('philips.com.au') > -1) {
  DEFAULT_LANG = "en";
  ALLOWED_LANG = ["en"];
} else {
  if (!!window.location && window.location.hostname.indexOf('dentalshop-au') > -1) {
    DEFAULT_LANG = "en";
    ALLOWED_LANG = ["en"];
  } else {
    if (!!window.location && window.location.hostname.indexOf('philips.de') > -1) {
      DEFAULT_LANG = "de";
      ALLOWED_LANG = ["de"];
    } else {
      if (!!window.location && window.location.hostname.indexOf('dentalshop-de.') > -1) {
        DEFAULT_LANG = "de";
        ALLOWED_LANG = ["de"];
      }
    }
  }
}

try {
  ALLOWED_LANG = environment['known_languages'];
} catch (e) {
  console.warn("please set 'known_languages' in env");
}

try {
  DEFAULT_LANG = environment['current_language'];
} catch (e) {
    console.warn("please set 'current_language' in env");
}



console.log("we have DEFAULT_LANG = ", DEFAULT_LANG);
if(!!window.location && window.location.hostname.indexOf('avent') > -1) {
  trigger_exit_poll(window.location.pathname, 'avent');
} else {
  trigger_exit_poll(window.location.pathname, DEFAULT_LANG);
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'Philips Sonicare for professionals';
    private body: HTMLElement = this.document.body;
    public config: ToasterConfig =
          new ToasterConfig({
              showCloseButton: true,
              timeout: 4500,
	            positionClass: "toast-bottom-center"
          });

    constructor( //angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
                titleService: Title,
                dataService: DataService,
                @Inject(DOCUMENT) private document: any,
                translate: TranslateService,
                router: Router) {

    translate.addLangs(ALLOWED_LANG);
    translate.setDefaultLang(DEFAULT_LANG);

    router.events.subscribe( (event: Event) => {
        window.scrollTo(0, 0);
        this.body.style.overflow = 'auto';
        let lng = DEFAULT_LANG;
        if(dataService.current_language){
          lng = dataService.current_language;
        }
        
        // trigger exit poll on evenry page change, not only on the first page loaded
        if (event instanceof NavigationStart) {
          if(!!event.url && event.url.indexOf('login') > -1 || event.url.indexOf('create') > -1 || event.url.indexOf('shop') > -1) {
            router.navigate(['/please-wait']);
            if (dataService.main_country === 'NL' && dataService.current_language === 'nl') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/nl5z-04/nl_NL/EUR/login'
            }
            else if (dataService.main_country === 'NL' && dataService.current_language === 'fr') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/fr/login'
            }
            else if (dataService.main_country === 'CH' && dataService.current_language === 'de') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/ch5a-04/de_CH/EUR/login'
            }
            else if (dataService.main_country === 'CH' && dataService.current_language === 'fr') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/ch5a-04/fr_CH/EUR/login'
            }
            else if (dataService.main_country === 'DE' && dataService.current_language === 'de') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/de5a-04/de_DE/EUR/login'
            }
            // else if (dataService.main_country === 'AT' && dataService.current_language === 'de') {
            //   window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/at5a-04/de_AT/EUR/login'
            // }
            else if (dataService.main_country === 'GB') {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/gb11-04/en_GB/GBP/login'
            }
            else {
              window.location.href = 'https://www.b2bshop.philips.com/philipsb2bstorefront/en/login'
            }
          }
        }

        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            let poll = lng;
            if(!!window.location && window.location.hostname.indexOf('avent') > -1) {
              poll = 'avent';
            };
            // trigger virtual page vieuw event:
            dataService.virtual_pageview(event.urlAfterRedirects); // the datalayer may not yet exist the first time we hit a page
            trigger_exit_poll(event.urlAfterRedirects, poll);
          }, 200);
        }
      }
    );

    let browserLang = translate.getBrowserLang();
    if( browserLang.match(/fr/) ){
      translate.use('fr');
      trigger_exit_poll(window.location.pathname, 'fr');
    }
    if(!!window.location.search && window.location.search.indexOf('lang') > -1){
      for(let param of window.location.search.split('?')[1].split('&')){
        let pv = param.split('=');
        try {
          if (pv[0] == 'lang' && ALLOWED_LANG.indexOf(pv[1]) > -1){
            translate.use(pv[1]);
            trigger_exit_poll(window.location.pathname, pv[1]);
          };
        } catch (e) {

        }
      }
    }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/app.component.ts